import { render, staticRenderFns } from "./bandeau_resto.vue?vue&type=template&id=13b9af5a&scoped=true&"
import script from "./bandeau_resto.vue?vue&type=script&lang=js&"
export * from "./bandeau_resto.vue?vue&type=script&lang=js&"
import style0 from "./bandeau_resto.vue?vue&type=style&index=0&id=13b9af5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9af5a",
  null
  
)

export default component.exports